const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function scrollToFirstError() {
  setTimeout(() => {
    const el = document.querySelector(".border-destructive");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
  }, 50);
}

export function hasErrors(errors: Record<string, boolean>): boolean {
  return Object.values(errors).some(Boolean);
}

export function getAgentErrors(fields: {
  name: string;
  email: string;
  agencyId: string;
}): Record<string, boolean> {
  return {
    name: !fields.name.trim(),
    email: !fields.email.trim() || !EMAIL_REGEX.test(fields.email),
    agencyId: !fields.agencyId,
  };
}

export function getCOIErrors(fields: {
  email?: string;
}): Record<string, boolean> {
  return {
    email: !!fields.email && !EMAIL_REGEX.test(fields.email),
  };
}

export function getPolicyErrors(fields: {
  policyNumber: string;
  customerName: string;
  carrier: string;
  effectiveDate: string;
  expirationDate: string;
}): Record<string, boolean> {
  return {
    policyNumber: !fields.policyNumber.trim(),
    customerName: !fields.customerName.trim(),
    carrier: !fields.carrier,
    effectiveDate: !fields.effectiveDate,
    expirationDate: !fields.expirationDate || (!!fields.effectiveDate && fields.expirationDate <= fields.effectiveDate),
  };
}
